export class Tool {
    constructor(name, icon = null) {
        this.name = name;
        this.icon = icon;
    }
}
//# sourceMappingURL=Tool.js.map